import { render, staticRenderFns } from "./CreatePublication.vue?vue&type=template&id=7bcb5d0e&"
import script from "./CreatePublication.vue?vue&type=script&lang=js&"
export * from "./CreatePublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports